import React from "react";

import styled from "styled-components";
function Footer() {
  return (
    <Container>
      <Main>
        <Logo>
          <img src="./photos/final_1.svg" alt="" />
          <Social>
            <Infor>
              <svg
                width="6"
                height="13"
                viewBox="0 0 6 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.89797 12.1949V6.77739H5.67504L5.93919 4.65625H3.89797V3.30517C3.89797 2.69308 4.06379 2.27401 4.91794 2.27401H6.00024V0.382887C5.47364 0.324845 4.94432 0.29682 4.4147 0.29894C2.84395 0.29894 1.7655 1.28515 1.7655 3.09563V4.65228H0V6.77343H1.76935V12.1949H3.89797Z"
                  fill="black"
                />
              </svg>
            </Infor>
            <Infor>
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.99542 3.18701C5.17819 3.18701 4.39444 3.50884 3.81657 4.08169C3.23871 4.65454 2.91406 5.43149 2.91406 6.24163C2.91406 7.05176 3.23871 7.82871 3.81657 8.40157C4.39444 8.97442 5.17819 9.29624 5.99542 9.29624C6.81265 9.29624 7.59641 8.97442 8.17427 8.40157C8.75214 7.82871 9.07678 7.05176 9.07678 6.24163C9.07678 5.43149 8.75214 4.65454 8.17427 4.08169C7.59641 3.50884 6.81265 3.18701 5.99542 3.18701ZM5.99542 8.22541C5.46451 8.22541 4.95534 8.01633 4.57992 7.64418C4.20451 7.27202 3.9936 6.76727 3.9936 6.24097C3.9936 5.71466 4.20451 5.20991 4.57992 4.83775C4.95534 4.4656 5.46451 4.25652 5.99542 4.25652C6.52634 4.25652 7.03551 4.4656 7.41092 4.83775C7.78634 5.20991 7.99724 5.71466 7.99724 6.24097C7.99724 6.76727 7.78634 7.27202 7.41092 7.64418C7.03551 8.01633 6.52634 8.22541 5.99542 8.22541Z"
                  fill="black"
                />
                <path
                  d="M9.19873 3.78706C9.59548 3.78706 9.91711 3.46822 9.91711 3.07492C9.91711 2.68162 9.59548 2.36279 9.19873 2.36279C8.80198 2.36279 8.48035 2.68162 8.48035 3.07492C8.48035 3.46822 8.80198 3.78706 9.19873 3.78706Z"
                  fill="black"
                />
                <path
                  d="M11.6823 2.35065C11.528 1.95573 11.2923 1.5971 10.9901 1.2977C10.688 0.998295 10.3261 0.764731 9.92771 0.611953C9.46147 0.438451 8.96892 0.344635 8.47102 0.334501C7.82931 0.306755 7.62607 0.298828 5.99879 0.298828C4.37151 0.298828 4.16294 0.298828 3.52655 0.334501C3.02904 0.344117 2.53683 0.437952 2.0712 0.611953C1.67267 0.764553 1.31072 0.998054 1.00856 1.29748C0.706411 1.5969 0.470732 1.95563 0.316648 2.35065C0.141596 2.81282 0.0471775 3.30115 0.0374388 3.79473C0.00878488 4.43023 0.00012207 4.63171 0.00012207 6.24556C0.00012207 7.85874 0.000122065 8.06419 0.0374388 8.69639C0.0474344 9.19052 0.141393 9.67804 0.316648 10.1411C0.471164 10.536 0.707072 10.8946 1.0093 11.194C1.31152 11.4934 1.67342 11.7269 2.07187 11.8798C2.53662 12.0603 3.02902 12.1608 3.52789 12.1771C4.1696 12.2048 4.37285 12.2134 6.00012 12.2134C7.6274 12.2134 7.83597 12.2134 8.47236 12.1771C8.9702 12.1671 9.46274 12.0735 9.92904 11.9003C10.3274 11.7472 10.6891 11.5134 10.9912 11.2139C11.2933 10.9144 11.5291 10.5558 11.6836 10.1609C11.8589 9.69852 11.9528 9.21099 11.9628 8.71686C11.9915 8.08137 12.0001 7.87988 12.0001 6.26604C12.0001 4.65219 12.0001 4.4474 11.9628 3.81521C11.955 3.31465 11.8601 2.81918 11.6823 2.35065ZM10.8706 8.6475C10.8663 9.02821 10.7962 9.40537 10.6634 9.7626C10.5633 10.0195 10.4101 10.2528 10.2136 10.4474C10.0172 10.6421 9.78175 10.7938 9.52256 10.8929C9.1662 11.024 8.78979 11.0935 8.40972 11.0983C7.77667 11.1274 7.59808 11.1347 5.9748 11.1347C4.35019 11.1347 4.18426 11.1347 3.53922 11.0983C3.15934 11.0937 2.7831 11.0242 2.42704 10.8929C2.16695 10.7944 1.9306 10.643 1.73328 10.4483C1.53596 10.2536 1.38206 10.02 1.28155 9.7626C1.15058 9.40921 1.08052 9.03649 1.07431 8.66005C1.04566 8.03248 1.03899 7.85544 1.03899 6.24622C1.03899 4.63633 1.03899 4.47184 1.07431 3.83172C1.07862 3.45123 1.14872 3.07429 1.28155 2.71729C1.4848 2.19607 1.90128 1.78584 2.42704 1.58634C2.78328 1.45563 3.1594 1.38615 3.53922 1.38089C4.17293 1.35249 4.35086 1.34456 5.9748 1.34456C7.59875 1.34456 7.76534 1.34456 8.40972 1.38089C8.78982 1.38543 9.16629 1.45493 9.52256 1.58634C9.78173 1.68561 10.0171 1.8375 10.2136 2.03226C10.41 2.22703 10.5632 2.46036 10.6634 2.71729C10.7944 3.07068 10.8644 3.44339 10.8706 3.81983C10.8993 4.44806 10.9066 4.62444 10.9066 6.23433C10.9066 7.84355 10.9066 8.01663 10.878 8.64816H10.8706V8.6475Z"
                  fill="black"
                />
              </svg>
            </Infor>
            <Infor>
              <svg
                width="13"
                height="10"
                viewBox="0 0 13 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.7357 1.68449C12.6617 1.4154 12.5171 1.17 12.3163 0.972717C12.1155 0.77543 11.8655 0.633137 11.5912 0.56C10.574 0.2862 6.50462 0.281743 6.50462 0.281743C6.50462 0.281743 2.4359 0.277286 1.41807 0.538988C1.14392 0.61549 0.894424 0.759796 0.69355 0.958051C0.492676 1.15631 0.347163 1.40185 0.270982 1.67112C0.0027213 2.66826 0.000123022 4.7364 0.000123022 4.7364C0.000123022 4.7364 -0.00247513 6.81474 0.263836 7.80169C0.413231 8.34738 0.851671 8.77845 1.40898 8.92554C2.43655 9.19934 6.49488 9.2038 6.49488 9.2038C6.49488 9.2038 10.5642 9.20826 11.5814 8.94719C11.8559 8.87418 12.1061 8.73222 12.3074 8.53533C12.5087 8.33845 12.6541 8.09347 12.7292 7.82461C12.9981 6.82811 13 4.7606 13 4.7606C13 4.7606 13.013 2.68163 12.7357 1.68449ZM5.20294 6.65237L5.20619 2.8319L8.58835 4.74532L5.20294 6.65237Z"
                  fill="black"
                />
              </svg>
            </Infor>
          </Social>
        </Logo>

        <Contact>
          <h3>Contact</h3>
          <p>naturalagribaler@gmail.com</p>
        </Contact>
      </Main>
      <Credit>
        <p>
          Designed by <a href="https://codone.netlify.app">Codone</a>
        </p>
      </Credit>
    </Container>
  );
}
const Container = styled.div`
  width: 100%;
  min-height: 150px;
  padding: 15px 0px 0px 0px;
  height: fit-content;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100 !important;
  margin-top: 100px;
  overflow-x: hidden;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    height: fit-content;
    justify-content: space-between;
    min-height: 290px;

    &::after {
      display: none;
    }
  }
`;
const Logo = styled.div`
  img {
    width: 180px;
  }
`;
const Main = styled.div`
  width: 90%;
  height: 100%;
  padding: 25px 0px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    min-height: 240px;
  }
`;

const Social = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;

  justify-content: space-evenly;
  width: 180px;
`;
const Infor = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 18px;
    height: 18px;
  }
`;

const Contact = styled.div`
  margin-top: 100px;
  h3 {
    font-size: 20px;
    font-weight: 500;
    line-height: 21px;
  }
  p {
    font-size: 14px;
    margin-top: 10px;
    color: #717ff5;
    cursor: pointer;
  }

  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

const Credit = styled.div`
  width: 100%;
  height: 53px;
  background-color: #f7f8fe;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  padding: 10px 0px;

  a {
    text-decoration: none;
  }
`;
export default Footer;
